var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51973 1.33099C7.90541 0.954231 8.4241 0.744698 8.96329 0.747838C9.50248 0.750977 10.0187 0.966536 10.4 1.34776C10.7812 1.72898 10.9968 2.24513 11 2.78426C11.0031 3.32338 10.7935 3.842 10.4167 4.22764L9.95606 4.68827L7.05904 1.79162L7.51973 1.33099ZM6.57219 2.2791L1.06394 7.78666C0.83854 8.01229 0.682087 8.29745 0.612892 8.60877L0.00828616 11.3285C-0.00435959 11.3851 -0.00250602 11.4439 0.013675 11.4996C0.029856 11.5553 0.0598402 11.606 0.100846 11.647C0.141851 11.688 0.192549 11.7179 0.248237 11.7341C0.303924 11.7503 0.362796 11.7522 0.419391 11.7395L3.1229 11.1384C3.44479 11.0668 3.73957 10.9048 3.97266 10.6716L9.4692 5.17575L6.57219 2.2791Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencel);
export default __webpack_public_path__ + "static/media/pencel.935db9734e6c0519625ae2305cfb30f4.svg";
export { ForwardRef as ReactComponent };